import { useMemo } from "react"
import { useSelector } from "react-redux"
import { UNASSIGNED_ID, CALENDAR_TABS } from "../constants"

const useListViewData = (events, activeTab, crewIds, equipmentIds, categoryIds, roleIds) => {
  const allEquipment = useSelector((state) =>
    (state.calendar?.calendarEquipment || []).map((eq) => ({ id: eq.id, name: eq.equipment_title }))
  )
  const calendarCrew = useSelector((state) => state.staff?.calendarCrew || [])

  const crewMembers = useMemo(() => {
    if (activeTab !== CALENDAR_TABS.CREW) return []
    const active = calendarCrew
      .filter((c) => c.status?.toLowerCase() === "active")
      .map((c) => ({ id: c.id, name: c.name }))

    const assignedCrewIds = new Set()
    if (roleIds?.length > 0) {
      events.forEach((ev) => {
        (ev.assigned_crew || []).forEach((c) => {
          if (c.profile_id) assignedCrewIds.add(c.profile_id)
          if (c.id) assignedCrewIds.add(c.id)
        })
      })
    }

    if (crewIds?.length > 0 && roleIds?.length > 0) {
      const merged = new Set([...crewIds.filter((id) => id !== UNASSIGNED_ID), ...assignedCrewIds])
      return active.filter((c) => merged.has(c.id))
    }
    if (crewIds?.length > 0) return active.filter((c) => crewIds.includes(c.id))
    if (roleIds?.length > 0) return active.filter((c) => assignedCrewIds.has(c.id))
    return active
  }, [activeTab, calendarCrew, crewIds, roleIds, events])

  const equipmentList = useMemo(() => {
    if (activeTab !== CALENDAR_TABS.EQUIPMENT) return []
    const assignedIds = new Set()
    if (categoryIds?.length > 0) {
      events.forEach((ev) => {
        (ev.assigned_equipment || []).forEach((item) => {
          if (item.boat_id) assignedIds.add(item.boat_id)
          if (item.id) assignedIds.add(item.id)
        })
      })
    }
    if (equipmentIds?.length > 0 && categoryIds?.length > 0) {
      const merged = new Set([...equipmentIds, ...assignedIds])
      return allEquipment.filter((eq) => merged.has(eq.id))
    }
    if (equipmentIds?.length > 0) return allEquipment.filter((eq) => equipmentIds.includes(eq.id))
    if (categoryIds?.length > 0) return allEquipment.filter((eq) => assignedIds.has(eq.id))
    return allEquipment
  }, [activeTab, allEquipment, equipmentIds, categoryIds, events])

  return { crewMembers, equipmentList }
}

export default useListViewData
